import Vue from "vue";
import { SELECT_AIRPORTS, CURRENT_USER } from "@/store/mutation-types";
import { MessageBox, Message } from "element-ui";
import router from "@/router/index.js";
import moment from "moment";
/**
 *
 *是否包含国际机场
 * @export
 * @param {*} [airports=[]]
 * @return {* Boolean}
 */
export function hasIntAirport(airports = []) {
  const airportData = Vue.ls.get(SELECT_AIRPORTS) || [];
  const intAirports = [];
  airportData.intList && airportData.intList.map(item => {
    if (item.airports && item.airports.length > 0) {
      item.airports.map(airport => {
        if (airport.commonAirports?.length) {
          intAirports.push(...airport.commonAirports);
        }
      });
    }
  });
  return intAirports.some(item => airports.some(v => v == item.airportCode));
}

/**
 *校验是否登录
 * @export
 * @return {*} 
 */
export function checkLogin() {
  const currentUser = Vue.ls.get(CURRENT_USER);
  if (currentUser == null || currentUser.phone === undefined || currentUser.phone.length <= 0) {
    MessageBox.confirm("你还没有登录，请先登录后在进行预订", "提示", {
      confirmButtonText: "立即登录",
      cancelButtonText: "取消",
      type: "warning",
      customClass: "m-message-box"
    })
      .then(() => {
        Vue.ls.set("URL_REDIRECT", window.location.href);
        router.push({
          path: "/login",
          query: { t: new Date().getTime() }
        });
      })
      .catch(() => {
        return false;
      });
    return false;
  }
  return true;
}


export function getAge(birthday, current) {
  if (!birthday || !current) {
    return 30;
  }
  // console.log("生日：", birthday);
  // console.log("航班起飞时间：", current);
  //计算两个日期相差多少年
  var startDate = new Date(birthday);
  var endDate = new Date(current);
  var yearNum = endDate.getFullYear() - startDate.getFullYear();
  //获取两个日期（月+日）部分
  var sStr = birthday.substring(5, 10);
  var eStr = current.substring(5, 10);
  //判断两个日期大小
  //判断是否过生日
  if (new Date(sStr) > new Date(eStr)) {
    return yearNum - 1;
  } else {
    return yearNum;
  }
}

export function getPassType(birthday, flightDate) {
  if (!birthday || !flightDate) return "ADT";
  const newAge = getAge(moment(birthday).format("YYYY-MM-DD"), moment(flightDate).format("YYYY-MM-DD"));
  if (newAge >= 12) {
    return "ADT";
  } else if (newAge >= 2) {
    return "CHD";
  } else {
    return "INF";
  }
}
